import React, { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEventContext } from "../../context/EventContext";
import { useLocaleContext } from "../../context/LocaleContext";
import { ModalContextProvider } from "../../context/ModalContext";
import { capitalizer } from "../../../../cp/utils";
import PageContainer from "../../components/PageContainer";
import Quizzes from "../../components/Quiz";

import "./style.scss";

const QuizzesPage = ({ children }) => {
    const {event, pages, watchKey} = useEventContext();
    const $locale = useLocaleContext();
    const { getProperty } = useLocaleContext();
    const params = useParams();
    const page = pages.find(({ type }) => type === 'quiz');
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        addPageStyles();
    }, [params]);

    function addPageStyles() {
        const quizPage = document.querySelector('.quiz-page-root');

        quizPage.style.backgroundImage = `url(${page.settings.backgroundUrl})`;

        page.settings.backgroundFixed
            ? quizPage.classList.add('quiz-page-root--background-fixed')
            : quizPage.classList.remove('quiz-page-root--background-fixed')
    }

    const handleGoToQuizzes = () => {
        navigate(`/event/${watchKey}/quiz`);
    };

    return (
        <PageContainer>
            <ModalContextProvider>
                <section className={`${!!page.settings.backgroundUrl ? 'page-section-background' : ''} quiz-page ${page?.settings?.showSubstrate ? 'page-section-background--filled' : ''}`}>
                    <div className="quiz-page__content">
                        {page?.settings?.showTitle &&
                            <h1 className="quiz-page__title">
                                {!!page.settings ? page.settings[`title${capitalizer($locale.name)}`] : getProperty(event.moduleQuiz, 'titleText')}
                            </h1>
                        }
                        <Quizzes />
                    </div>
                </section>
                {children}
            </ModalContextProvider>
        </PageContainer>
    );
};

export default QuizzesPage;
